/* Sticky header helpers: exposes header height and a scrolled state */
(function () {
  var wrap = document.getElementById('shopify-section-header');
  if (!wrap) return;
  var root = document.documentElement;
  function setH() { root.style.setProperty('--header-h', wrap.offsetHeight + 'px'); }
  var compact = false, scrolled = false;
  function onScroll() {
    var y = window.scrollY;
    // The scrolled header is shorter; when it shrinks the browser re-anchors the page by the same amount.
    // A wide dead-zone (on past 64px, off under 4px) stops that feedback loop flickering the header.
    if (!scrolled && y > 64) { scrolled = true; root.classList.add('is-scrolled'); }
    else if (scrolled && y < 4) { scrolled = false; root.classList.remove('is-scrolled'); }
    // fold the mobile logo row away once the shopper is browsing; hysteresis stops it flickering
    if (!compact && y > 140) { compact = true; root.classList.add('is-compact'); }
    else if (compact && y < 40) { compact = false; root.classList.remove('is-compact'); }
  }
  setH(); onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', setH);
  if ('ResizeObserver' in window) new ResizeObserver(setH).observe(wrap);
})();

/* Back to top */
(function () {
  var b = document.createElement('button');
  b.type = 'button';
  b.className = 'to-top';
  b.setAttribute('aria-label', 'Back to top');
  b.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  document.body.appendChild(b);
  b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  function on() { b.classList.toggle('is-on', window.scrollY > window.innerHeight * 1.2); }
  window.addEventListener('scroll', on, { passive: true });
  on();
})();
/* Accordions: opening one item closes its open siblings (FAQs, filters, menu groups, footer columns on mobile) */
(function () {
  var wideFooter = window.matchMedia('(min-width: 750px)');
  document.addEventListener('click', function (e) {
    var sum = e.target.closest('summary');
    if (!sum) return;
    var d = sum.parentElement;
    if (!d || d.tagName !== 'DETAILS' || d.open || !d.parentElement) return;
    if (d.hasAttribute('data-ft-col') && wideFooter.matches) return;
    if (d.hasAttribute('data-calc-toggle')) return;
    Array.prototype.forEach.call(d.parentElement.children, function (s) {
      if (s !== d && s.tagName === 'DETAILS' && s.open) s.open = false;
    });
  });
})();
